export default (function (sel) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return base.querySelector(sel);
});